import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { FormControlLabel, Stack, Switch, Typography } from '@mui/material'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAppSettings, setAppSettings } from '@/redux/reducers/app.reducer'

export function Appearance() {
  useLingui()
  const dispatch = useAppDispatch()
  const appSettings = useAppSelector(selectAppSettings)

  const handleToggle =
    (key: 'showOfflineButton' | 'showPatientQueue' | 'showFreshworkWidget' | 'preferWaitingRoom') =>
    (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      dispatch(setAppSettings({ [key]: checked }))
      localStorage.setItem(key, `${checked}`)
    }

  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        <Trans>Choose which elements to display in the header bar.</Trans>
      </Typography>

      <FormControlLabel
        control={<Switch checked={appSettings.showOfflineButton} onChange={handleToggle('showOfflineButton')} />}
        label={
          <Typography variant="body1">
            <Trans>Show offline button</Trans>
          </Typography>
        }
      />

      <FormControlLabel
        control={<Switch checked={appSettings.showPatientQueue} onChange={handleToggle('showPatientQueue')} />}
        label={
          <Typography variant="body1">
            <Trans>Show patient queue</Trans>
          </Typography>
        }
      />

      <FormControlLabel
        control={<Switch checked={appSettings.showFreshworkWidget} onChange={handleToggle('showFreshworkWidget')} />}
        label={
          <Typography variant="body1">
            <Trans>Show support widget</Trans>
          </Typography>
        }
      />

      <FormControlLabel
        control={<Switch checked={appSettings.preferWaitingRoom} onChange={handleToggle('preferWaitingRoom')} />}
        label={
          <Typography variant="body1">
            <Trans>Waitings rooms first when creating a consultation</Trans>
          </Typography>
        }
      />
    </Stack>
  )
}
